import styled from "styled-components";

import { device } from "utils/sizes";
import { colourScheme } from "utils/styling/colours";

export const ModalContainer = styled.div`
    display: flex;
    overflow-y: auto;
    flex-direction: column;
    gap: 2rem;
    padding: 2rem;
    background-color: ${colourScheme.primaryLight};
    text-align: center;
    align-items: center;
    border-radius: 0.5rem;
    max-width: 26rem;
    & > hr {
        width: 100%;
        color: ${colourScheme.white};
    }
`;

export const Container = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
    gap: 1rem;
    padding: 1rem 0rem;
    align-items: center;
    width: 100%;
    @media (max-width: ${device.md}) {
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }
`;

export const TitleContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const Icon = styled.div`
    all: unset;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 1.5rem;
    width: 1.5rem;
    cursor: pointer;
    position: relative;
    margin-left: 0.2rem;
    svg,
    img {
        opacity: 0.5;
        height: 100%;
        width: 100%;
    }
    & > span {
        padding: 0.25rem;
        color: ${colourScheme.secondary};
    }
`;
